'use strict';

const NOTIFICATION =
  {
    EMAIL_TO_UNIT_REP_ON_FORM_SUBMIT: {
      subject: 'Thanks for Submitting your Slip-Resistant Footwear Program Enrollment Form',
      template: 'email-to-unit-rep-on-form-submit.hbs'
    }, //the application was submitted and sending email to unit rep
    EMAIL_TO_CAMPUS_ADMIN_ON_FORM_SUBMIT: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Pending EHS Liaison Review',
      template: 'email-to-campus-admin-on-form-submit.hbs'
    },//the application was submitted and review req to the campus liaison for the first review
    EMAIL_TO_UNIT_REP_ON_FORM_APPROVE_BY_CAMPUS_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Approved by EHS Liaison',
      template: 'email-to-unit-rep-on-form-approve-by-campus-admin.hbs'
    },//the application was approved by campus liaison and sending email to unit rep
    EMAIL_TO_UNIT_REP_ON_FORM_DECLINE_BY_CAMPUS_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Denied by EHS Liaison',
      template: 'email-to-unit-rep-on-form-decline-by-campus-admin.hbs'
    },//the application was Decline and sending decline email to unit rep
    EMAIL_TO_UCOP_ADMIN_ON_FORM_APPROVE_BY_CAMPUS_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Pending UCOP EHS Review',
      template: 'email-to-ucop-admin-on-form-approve-by-campus-admin.hbs'
    },//the application was approved by campus liaison and review req to the UCOP for the second review
    EMAIL_TO_UNIT_REP_ON_FORM_APPROVE_BY_UCOP_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Approved by UCOP EHS',
      template: 'email-to-unit-rep-on-form-approve-by-ucop-admin.hbs'
    },//the application was approved by UCOP admin and sending email to unit rep
    EMAIL_TO_UCOP_ADMIN_ON_FORM_APPROVE_BY_UCOP_ADMIN_TO_SETUP_ACCOUNT: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Pending Supplier Account Creation',
      template: 'email-to-ucop-admin-on-form-approve-by-ucop-admin-to-setup-account.hbs'
    },//the application was approved by campus admin and pending supplier account creation req to the Veronica
    EMAIL_TO_UNIT_REP_ON_FORM_DECLINE_BY_UCOP_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Denied by UCOP EHS',
      template: 'email-to-unit-rep-on-form-decline-by-ucop-admin.hbs'
    },//the application was decline and sending decline email to unit rep, primary contact and campus liaison
    EMAIL_TO_VENDOR_FOR_ACCOUNT_CREATION: {
      subject: 'University of CA New Unit Request',
      template: 'email-to-vendor_for_account_creation.hbs'
    },//the application was approve by ucop admin and sending request email to vendor (CC:ucop admin) for create account
    EMAIL_TO_UNIT_REP_ON_ENABLE_ORDERING: {
      subject: 'Slip-Resistant Footwear Program Account and Ordering Information',
      template: 'email-to-unit-rep-on-enable-ordering.hbs'
    },
    EMAIL_TO_UNIT_REP_ON_FORM_CORRECTION_REQ_BY_CAMPUS_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Correction(s) Required by EHS Liaison',
      template: 'email_to_unit_rep_on_form_correction_req_by_campus_admin.hbs'
    },//Trigger email to Submitter when application is returned for correction by EHS Liaison
    EMAIL_TO_UNIT_REP_ON_FORM_CORRECTION_REQ_BY_UCOP_ADMIN: {
      subject: 'Slip-Resistant Footwear Program Enrollment Form Correction(s) Required by UCOP EHS',
      template: 'email_to_unit_rep_on_form_correction_req_by_ucop_admin.hbs'
    },//Trigger email to Submitter when application is returned for correction by UCOP EHS
    EMAIL_TO_PEOPLE_FOR_FORM_CHANGES_ON_AMENDMENT: {
      subject: 'Slip-Resistant Footwear Program Form Amended',
      template: 'email_to_people_for_form_changes_on_amendment.hbs'
    },//Trigger email to people for form changes on amendment
    EMAIL_TO_PEOPLE_FOR_EMPLOYEE_ROSTER_CHANGES_ON_AMENDMENT: {
      subject: 'Slip-Resistant Footwear Program Employee Roster Amended',
      template: 'email_to_people_for_employee_roster_changes_on_amendment.hbs'
    },//Trigger email to people for for employee  roster changes on amendment
    EMAIL_TO_PEOPLE_WHEN_ERROR_GROUP_CREATION: {
      subject: 'Error happened while creating group',
      template: 'error_happened_while_creating_group.hbs'
    },//Trigger email on error while creating group

  };

module.exports = NOTIFICATION;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/server/shared/constants/notification.constant.js
// module id = I3g/
// module chunks = 1